import { Button } from '@odc-shared/components';
import { Empty as EmptyIcon } from '@tencent/odc-iconpack';
import classNames from 'classnames';
import React from 'react';

import './index.scss';

export interface IEmpty {
  className?: string
  emptyTip?: string
  size?: 'sm' | 'md' | 'lg'
  emptyDesc?: string
  operate?: React.ReactNode | string
  onOperate?: (e: React.MouseEvent) => void
}
const Empty = (props: IEmpty) => {
  const { emptyTip = 'No data', className, size = 'md', emptyDesc, operate, onOperate } = props;
  return (
    <div className={classNames('odc-empty', className, {
      'odc-empty-sm': size === 'sm',
      'odc-empty-md': size === 'md',
      'odc-empty-lg': size === 'lg',
    })}
    >
      <EmptyIcon />
      <p className="odc-empty-tips">{emptyTip}</p>
      {emptyDesc && <p className="odc-empty-desc">{emptyDesc}</p>}
      {operate && <div className="odc-empty-operate" onClick={onOperate}>
        <Button size={size === 'lg' ? 'md' : 'sm'} className="font-normal">{operate}</Button>
      </div>}
    </div>
  );
};

export default Empty;